import { List } from 'immutable';
// @ts-expect-error Untyped import
import { trackEvent, EVENTS } from '../../lib/usageTracker';
import { submitSupportChatFeedback, submitAiSearchFeedback } from 'reporting-discover-components/api/aiSearchApi';
// @ts-expect-error Untyped import
import { useShowDialog } from 'reporting-action-components/dialog/ducks';
import AiSearchResultItem from '../../components/aiSearchResults/AiSearchResultItem';
import { SINGLE_REPORT_VIEWER } from 'reporting-action-components/dialog/dialogTypes';
import AiSearchResultsEmpty from '../../components/aiSearchResults/AiSearchResultsEmpty';
import { getIsUngatedToUseChirpEndpoints } from '../../selectors/gatesSelector';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const POSITIVE_FEEDBACK = 1;
const NEGATIVE_FEEDBACK = -1;
const AiSearchResultsContainer = ({
  templateSuggestions = List(),
  search,
  chatId
}) => {
  const showDialog = useShowDialog();
  const isUngatedToUseChirpEndpoints = useSelector(getIsUngatedToUseChirpEndpoints);
  const handleResultClick = (template, templateKey) => {
    trackEvent(EVENTS.openSearchResultTemplate, {
      templateKey,
      filterValue: search,
      subscreen: 'global-search',
      isAiPowered: true
    });
    trackEvent(EVENTS.openReport, {
      templateKey,
      subscreen: 'global-search'
    });
    showDialog({
      dialogType: SINGLE_REPORT_VIEWER,
      dialogProps: {
        report: template
      }
    });
  };
  const handleResultFeedbackClick = ({
    vote
  }, templateKey) => {
    const readableVote = vote === -1 ? 'thumbsDown' : 'thumbsUp';
    const requestBody = Object.assign({
      correlationId: chatId
    }, vote === -1 ? {
      rejectedValues: [templateKey]
    } : {
      acceptedValues: [templateKey]
    });
    if (isUngatedToUseChirpEndpoints) {
      void submitAiSearchFeedback(requestBody);
    } else {
      void submitSupportChatFeedback(requestBody);
    }
    trackEvent(EVENTS.submitAiSearchFeedback, {
      templateKey,
      action: readableVote,
      filterValue: search,
      subcreen: 'global-search'
    });
  };
  if (!templateSuggestions || templateSuggestions.size === 0) {
    return /*#__PURE__*/_jsx(AiSearchResultsEmpty, {});
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: templateSuggestions.map((suggestion, index) => {
      const templateKey = suggestion.templateKey;
      const template = suggestion.template;
      const explanation = suggestion.explanation;
      return /*#__PURE__*/_jsx(AiSearchResultItem, {
        template: template,
        templateKey: templateKey,
        messageId: index,
        explanation: explanation || '',
        onResultClick: handleResultClick,
        onResultFeedbackClick: handleResultFeedbackClick
      }, templateKey);
    })
  });
};
export default AiSearchResultsContainer;